<script setup lang="ts">
/*
 * Language switcher: an inline segmented pill (account menu, mobile drawer).
 * Only calls `setLocale` — the i18n module owns the rest.
 */
import { useI18n } from 'vue-i18n';
import { LOCALE_LABELS, SUPPORTED_LOCALES, setLocale } from '../../i18n';

const { t, locale } = useI18n();
</script>

<template>
  <div role="radiogroup" :aria-label="t('header.language.aria')" class="inline-flex rounded-full border border-border bg-bg-base p-0.5">
    <button
      v-for="l in SUPPORTED_LOCALES"
      :key="l"
      type="button"
      role="radio"
      :aria-checked="locale === l"
      class="h-8 min-w-12 rounded-full px-3 font-heading text-[11px] font-bold transition-colors"
      :class="locale === l ? 'bg-accent text-text-inv' : 'text-text-dim hover:text-text-base'"
      @click="setLocale(l)"
    >{{ LOCALE_LABELS[l].short }}</button>
  </div>
</template>
